<template>
  <Teleport to="#app">
    <div class="modal" :class="{'modal-open': reserve}">
      <div class="modal-box bg-red-custom-3 w-11/12 max-w-xl p-3 sm:p-6">
        <ShieldExclamationIcon class="w-24 h-24 mx-auto text-red-custom-4" />
        <p class="pt-4 text-red-custom-4">
          {{ __('This product is currently not available, you can reserve the desired product so that it will be invoiced for you in the reservation menu, and if the balance is charged, we will inform you through notification (messages) that we have finalized your invoice and the product will be sent to you. You will be sent.')}}
        </p>
        <p class="text-black">{{__('Note that the product will be invoiced for you at the current price!')}}</p>
        <div class="modal-action">
          <label class="btn btn-success btn-sm text-xs sm:text-sm" @click="productReserve(count)">{{ __('I make a reservation') }}</label>
          <label class="btn btn-error btn-sm text-xs sm:text-sm" @click="productReserve(-1)">{{ __('I have no desire') }}</label>
          <div class="flex rounded-lg p-1 w-24 items-center lg:mx-auto odd:bg-white quantity">
            <button class="btn btn-ghost btn-square btn-xs bg-gray-custom-6 border-0" @click="changeQuantity(count + 1)">
              <PlusIcon class="w-4 h-4 text-success" />
            </button>
            <input dir="ltr" type="number" class="w-full h-5 text-center bg-transparent outline-none text-gray-custom-1 flex items-center justify-center" v-model.number="count">
            <button class="btn btn-ghost btn-square btn-xs bg-gray-custom-6 border-0" @click="changeQuantity(count - 1)">
              <MinusIcon class="w-4 h-4 text-error" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </Teleport>
</template>
<script setup>
import { ShieldExclamationIcon,PlusIcon,MinusIcon } from "@heroicons/vue/24/outline";
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps(['reserve']);
const emit = defineEmits(['change']);
const count = ref(0);
const {reserve} = toRefs(props);
watch(reserve,(value) => count.value = value?.quantity);
const productReserve = (quantity) => emit('change', props.reserve, quantity);
const changeQuantity = (quantity) => {
  if(quantity < 0) return true;
  count.value = quantity;
};
</script>